/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommFooterViewProps } from './ecomm-footer';

/**
 *
 * EcommFooterView component
 * @extends {React.PureComponent<IEcommFooterViewProps>}
 */
export class EcommFooterView extends React.PureComponent<IEcommFooterViewProps> {
  public state: any = { hasMounted: false };

  public componentDidMount(): void {
    if (!this.state.hasMounted) {  
      this.setState({ hasMounted: true });
    }
  }

  public render(): JSX.Element | null {
    if (!this.state.hasMounted) {
      return null;
    }

    const { config } = this.props;
  
    return (
      <div className='ecomm-footer'>
        <div className='back-to-top'><a href='#main'>{config.backToTop}</a></div>
        {this._renderDetails()}
        {this._renderOthers()}
      </div>
    );
  }

  private _renderDetails(): JSX.Element | null {
    const { config, information, openingHoursDescription, etiquetteDescription } = this.props;

    const contactUrl = config.contactUrl?.linkUrl ? config.contactUrl?.linkUrl.destinationUrl : null;

    return (
      <div className='row ecomm-footer-details'>
        <div className='info col-12 col-sm-4'>
            <h5>{config.mainTitle}</h5>
            <p className='information' id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>{information}</p>
            {contactUrl && <a className='contact-link' href={contactUrl}>{config.contactUrl?.linkText}</a>}
            <div><div className='social-media-text'>{config.socialMediaPrompt}</div></div>
            <div>
              <div className='row'>
                {config.socialMedias && config.socialMedias.map(item => {
                  return <a className='col-auto mb-3 social-media-icon' href={item.url}><img src={item.image.src} alt='' role='presentation'/></a>;
                })}
              </div>
            </div>
        </div>
        <div className='info col-12 col-sm-4'>
          <p className='sub-title'>{config.openingHoursTitle}</p>
          <p className='content' id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>{openingHoursDescription}</p>
        </div>
        <div className='info col-12 col-sm-4'>
          <p className='sub-title'>{config.etiquetteTitle}</p>
          <p className='content' id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>{etiquetteDescription}</p>
        </div>
      </div>
    );
  }

  private _renderOthers(): JSX.Element | null {
    const { config, links } = this.props;

    return (
      <div className='row ecomm-footer-others'>
        <div className='col-sm-6 pages'>{links && links.map((link, index) => <span key={index}>{link}</span>)}</div>
        <p className='col-sm-6 copyright'>{config.copyright}</p>
      </div>
    );
  }
}

export default EcommFooterView;